export const normalizeSettingsSearch = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}⌘⇧⌥]+/gu, ' ').trim();
